export const hasAnyParamInSearch = (search: string, keys: readonly string[]): boolean => {
    const params = new URLSearchParams(search);

    return keys.some((key) => params.has(key));
};

export const parseCsvParam = (value: string | null): string[] => {
    if (!value) {
        return [];
    }

    return value
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
};
